import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet";

import { Link } from "react-router";
import Modal from "react-bootstrap/Modal";
import { Doughnut } from "react-chartjs-2";
import { browserHistory } from "react-router";
const ProgramView = () => {
 
  const [isModel, setIsModel] = useState(false);
  useEffect(() => {
 
  });

  
  return (
    <>
      <Helmet>
        <title>Supplier Program | {global.config.title}</title>
      </Helmet>

      <Modal show={isModel} onHide={(e) => setIsModel(false)}>
        <Modal.Header closeButton>
          <div className="d-block pt-3 text-center w-100 ml-3">
            <h3 className="modal-title"></h3>
          </div>
          
        </Modal.Header>
        <Modal.Body>
          
        </Modal.Body>
      </Modal>

      <div>
        <div className="row">
          <div className="col-lg-12">
            <h6>Settlement & Repayment</h6>
          </div>
        </div>
      </div>
      <div className="row"> 
        <div className="col-lg-4">
            <div className="settlement-option recommended">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-start">
                <div className="icon-wrap text-success">
                  <i className="fa fa-calendar" />
                </div>
                <div>
                  <h6>
                    Pay all due this week
                    <span className="badge badge-success ml-1">
                      Recommended
                    </span>
                  </h6>
                  <p className="text-muted mb-1">
                    Settle all invoices due in the next 7 days and stay
                    compliant.
                  </p>
                  <small className="text-muted">
                    Covers 12 invoices · Restores $120,000 limit
                  </small>
                </div>
              </div>
              <button className="btn btn-primary">Continue</button>
            </div>
          </div>
          </div>
            <div className="col-lg-4">
          {/* Pay Oldest First */}
          <div className="settlement-option danger">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-start">
                <div className="icon-wrap text-primary">
                  <i className="fa fa-history text-danger" />
                </div>
                <div>
                  <h6>Pay overdue invoices </h6>
                  <p className="text-muted mb-1">
                    Automatically apply payment to the oldest funded invoices.
                  </p>
                  <small className="text-muted">
                    Reduces interest accumulation
                  </small>
                </div>
              </div>
              <button className="btn btn-outline-danger">Continue</button>
            </div>
          </div>
          </div>
            <div className="col-lg-4">
          {/* Pay Minimum to Stay Within Limit */}
          <div className="settlement-option">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-start">
                <div className="icon-wrap  ">
                  <i className="fa fa-money" />
                </div>
                <div>
                  <h6>Pay minimum to stay within limit</h6>
                  <p className="text-muted mb-1">
                    Pay the minimum amount required to restore availability.
                  </p>
                  <small className="text-muted">
                    Fastest option · Lowest immediate cash out
                  </small>
                </div>
              </div>
              <button className="btn btn-outline-secondary">Continue</button>
            </div>
          </div>
        </div>

      </div>

      <div className="row">
        <div className="col-lg-8">
          <div className="card">
            <div className="card-body">
              <div className="row mb-4">
                <div className="col-lg-4">
                  <div className="dropdown dash-dropdown show">
                    <button
                      className="btn dropdown-toggle btn-sm pr-sm-4 pr-3 p-2 w-100 text-left       dropdown-toggle  pr-sm-4 pr-3 pl-lg-2 w-100"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="true"
                    >
                      This Week
                    </button>
                    <div
                      className="dropdown-menu w-100 show"
                      aria-labelledby="dropdownMenuButton"
                      x-placement="top-start"
                      style={{
                        position: "absolute",
                        willChange: "transform",
                        top: 0,
                        left: 0,
                        transform: "translate3d(0px, -279px, 0px)",
                      }}
                    >
                      <a className="dropdown-item " href="#">
                        Two Weeks
                      </a>
                      <a className="dropdown-item " href="#">
                        This Month
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-8">
                  <button
                    onClick={(e)=> {
                      setIsModel(true);
                    }}
                    className="btn btn-light pull-right"
                  >
                    Quick Payment <i className="fa fa-plus-circle ml-2"></i>
                  </button>
                </div>
              </div>
              <div className="container">
                {/* Row 1 */}
                <div className="d-flex align-items-center border-bottom py-2">
                  <div className="mr-2">
                    <input type="checkbox" />
                  </div>
                  <div className="flex-grow-1">
                    <div className="font-weight-bold">ABC Groups</div>
                    <small className="text-muted d-block">
                      Invoice #INV-1001
                    </small>
                    <small className="text-muted">
                      Due: Feb 15, 2026{" "}
                      <span className="badge badge-danger">Overdue</span>
                    </small>
                  </div>
                  <div className="text-right">
                    <h6 className="mb-0">$1,200.00</h6>
                    <small className="text-muted">$856.25 Interest</small>
                  </div>
                </div>
                {/* Row 2 */}
                <div className="d-flex align-items-center border-bottom py-2">
                  <div className="mr-2">
                    <input type="checkbox" />
                  </div>
                  <div className="flex-grow-1">
                    <div className="font-weight-bold">
                      HYZ Constructions Private Limited
                    </div>
                    <small className="text-muted d-block">
                      Invoice #INV-1002
                    </small>
                    <small className="text-muted">
                      Due: Feb 20, 2026{" "}
                      <span className="badge badge-warning">Due Today</span>
                    </small>
                  </div>
                  <div className="text-right">
                    <h6 className="mb-0">$850.00</h6>
                    <small className="text-muted">$200 Interest</small>
                  </div>
                </div>
                {/* Row 3 */}
                <div className="d-flex align-items-center border-bottom py-2">
                  <div className="mr-2">
                    <input type="checkbox" />
                  </div>
                  <div className="flex-grow-1">
                    <div className="font-weight-bold">Hazel and co </div>
                    <small className="text-muted d-block">
                      Invoice #INV-1003
                    </small>
                    <small className="text-muted">Due: Feb 25, 2026</small>
                  </div>
                  <div className="text-right">
                    <h6 className="mb-0">$2,300.00</h6>
                    <small className="text-muted">$400 Interest</small>
                  </div>
                </div>
                {/* Row 4 */}
                <div className="d-flex align-items-center border-bottom py-2">
                  <div className="mr-2">
                    <input type="checkbox" />
                  </div>
                  <div className="flex-grow-1">
                    <div className="font-weight-bold">Jetz</div>
                    <small className="text-muted d-block">
                      Invoice #INV-1004
                    </small>
                    <small className="text-muted">Due: Mar 01, 2026</small>
                  </div>
                  <div className="text-right">
                    <h6 className="mb-0">$420.00</h6>
                    <small className="text-muted">$270 Interest</small>
                  </div>
                </div>
                <div className="d-flex align-items-center border-bottom py-2">
                  <div className="mr-2">
                    <input type="checkbox" />
                  </div>
                  <div className="flex-grow-1">
                    <div className="font-weight-bold">
                      Ultimate Dark Excellence
                    </div>
                    <small className="text-muted d-block">
                      Invoice #INV-1003
                    </small>
                    <small className="text-muted">Due: Feb 25, 2026</small>
                  </div>
                  <div className="text-right">
                    <h6 className="mb-0">$2,300.00</h6>
                    <small className="text-muted">$520 Interest</small>
                  </div>
                </div>
                <div className="d-flex align-items-center border-bottom py-2">
                  <div className="mr-2">
                    <input type="checkbox" />
                  </div>
                  <div className="flex-grow-1">
                    <div className="font-weight-bold">Geo Plumbing</div>
                    <small className="text-muted d-block">
                      Invoice #INV-1003
                    </small>
                    <small className="text-muted">Due: Feb 25, 2026</small>
                  </div>
                  <div className="text-right">
                    <h6 className="mb-0">$2,300.00</h6>
                    <small className="text-muted">$770 Interest</small>
                  </div>
                </div>
                <div className="d-flex align-items-center border-bottom py-2">
                  <div className="mr-2">
                    <input type="checkbox" />
                  </div>
                  <div className="flex-grow-1">
                    <div className="font-weight-bold">
                      IDEATE INTERNATIONAL DELIVERY SERVICE PTY. LTD.
                    </div>
                    <small className="text-muted d-block">
                      Invoice #INV-1003
                    </small>
                    <small className="text-muted">Due: Feb 25, 2026</small>
                  </div>
                  <div className="text-right">
                    <h6 className="mb-0">$2,300.00</h6>
                    <small className="text-muted">$1,200 Interest</small>
                  </div>
                </div>
                <div className="d-flex align-items-center   py-2">
                  <div className="mr-2">
                    <input type="checkbox" />
                  </div>
                  <div className="flex-grow-1">
                    <div className="font-weight-bold">Supplier Three</div>
                    <small className="text-muted d-block">
                      Invoice #INV-1003
                    </small>
                    <small className="text-muted">Due: Feb 25, 2026</small>
                  </div>
                  <div className="text-right">
                    <h6 className="mb-0">$2,300.00</h6>
                    <small className="text-muted">$600 Interest</small>
                  </div>
                </div>
                <button
                  className="btn btn-outline-secondary btn-block mt-4 mb-3"
                  onClick={() => {
                    browserHistory.push("/client/ep-programme/allProgram");
                  }}
                >
                  <i className="fa fa-arrow-down" /> Show More
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="card    ">
            <div className="card-body">
              {/* Title */}
              <h6 className="font-weight-bold mb-3">Settlement Summary</h6>
              {/* Amount */}
              <div className="mb-3 text-center">
                <small className="text-muted">Amount to Pay</small>
                <h2 className="mb-0">$50,000</h2>
              </div>
              {/* Impact */}
              <div className="border rounded p-2 mb-3  ">
                <div className="d-flex justify-content-between mb-3">
                  <span className="text-muted">Invoices Covered</span>
                  <strong>7</strong>
                </div>
                <div className="d-flex justify-content-between mb-3">
                  <span className="text-muted">Total Principle</span>
                  <strong>$35,000.00</strong>
                </div>
                <div className="d-flex justify-content-between mb-3">
                  <span className="text-muted">Interest &amp; Fees</span>
                  <strong>$15,000</strong>
                </div>
              </div>
              {/* Payment Method */}
              <h6 className="font-weight-bold mb-2">Payment Method</h6>
              <div className="custom-control custom-radio mb-2">
                <input
                  type="radio"
                  id="directDebit"
                  name="paymentMethod"
                  className="custom-control-input"
                  defaultChecked=""
                />
                <label className="custom-control-label" htmlFor="directDebit">
                  <strong>Direct Debit</strong>
                  <div className="text-muted small">
                    Recommended · Fast settlement
                  </div>
                </label>
              </div>
              <div className="custom-control custom-radio mb-3">
                <input
                  type="radio"
                  id="bankTransfer"
                  name="paymentMethod"
                  className="custom-control-input"
                />
                <label className="custom-control-label" htmlFor="bankTransfer">
                  <strong>Bank Transfer</strong>
                  <div className="text-muted small">Manual transfer</div>
                </label>
              </div>
              {/* CTA */}
              <button className="btn btn-primary btn-block">
                Pay $50,000 Now
              </button>
              {/* Helper */}
              <div className="text-center mt-2">
                <a href="#" className="small text-muted">
                  View payment breakdown
                </a>
              </div>
              <div
                style={{ border: "1px dashed #d0e7faff" }}
                className="alert   bg-white b-dashed-2 mt-5"
              >
                <div className="mb-3 text-cente ">
                  <small className="text-muted">
                    Availability after this payment
                  </small>
                  <div>
                    <h6 className="mb-0 text-primary">$150,000</h6>
                    <i className="fa fa-arrow-up pull-right text-secondary"></i>{" "}
                    <small className="text-primary">20% UP</small>
                  </div>
                  <small className="text-danger">
                    * Subjected to settlement
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProgramView;
